import { render, staticRenderFns } from "./ArchivedWeek.vue?vue&type=template&id=4261cba7&scoped=true&"
import script from "./ArchivedWeek.vue?vue&type=script&lang=ts&"
export * from "./ArchivedWeek.vue?vue&type=script&lang=ts&"
import style0 from "./ArchivedWeek.vue?vue&type=style&index=0&id=4261cba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261cba7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VDataTable})
